import { render, staticRenderFns } from "./ReturnsIcon.vue?vue&type=template&id=f2a59f0a&scoped=true"
import script from "./ReturnsIcon.vue?vue&type=script&lang=ts"
export * from "./ReturnsIcon.vue?vue&type=script&lang=ts"
import style0 from "./ReturnsIcon.vue?vue&type=style&index=0&id=f2a59f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a59f0a",
  null
  
)

export default component.exports